class Lead {
  id: number;
  name: string;
  type?: string;
  emailFrom?: string;
  partnerId?: number;
  expectedRevenue: string; // string because formatted
  probability: number;
  recurringRevenue?: string;
  recurringPlan?: string;

  static fromJSON(o: Object): Lead {
    const lead = new Lead();
    lead.id = o["id"];
    lead.name = o["name"];
    lead.type = o["type"];
    lead.emailFrom = o["email_from"];

    const partnerField = o["partner_id"];
    if (Array.isArray(partnerField) && partnerField.length > 0) {
      lead.partnerId = partnerField[0];
    } else if (typeof partnerField === "number") {
      lead.partnerId = partnerField;
    } else {
      lead.partnerId = undefined;
    }

    lead.probability = o["probability"];

    lead.expectedRevenue = this.removeDecimals(o["expected_revenue"]);

    if (o["recurring_revenue"]) {
      lead.recurringRevenue = this.removeDecimals(o["recurring_revenue"]);
      lead.recurringPlan = o["recurring_plan"];
    }

    return lead;
  }

  static copy(lead: Lead): Lead {
    const newLead = new Lead();
    newLead.id = lead.id;
    newLead.name = lead.name;
    newLead.type = lead.type;
    newLead.emailFrom = lead.emailFrom;
    newLead.partnerId = lead.partnerId;
    newLead.expectedRevenue = lead.expectedRevenue;
    newLead.probability = lead.probability;
    return newLead;
  }

  private static removeDecimals(revenue: string): string {
    if (revenue == null || typeof revenue !== "string") {
      return revenue;
    }
    if (revenue.search(/\.00\D*$/) != -1) {
      // if it ends with ".00" or ".00 $" or ".00 €", etc.
      return revenue.replace(/\.00/, "");
    } else if (revenue.search(/,00\D*$/) != -1) {
      // if it ends with ",00" or ",00 $" or ",00 €", etc.
      return revenue.replace(/,00/, "");
    }
    return revenue;
  }
}

export default Lead;
